import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","grid-list-lg":""}},[_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c(VCard,[_c(VToolbar,[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.label))]),_c(VSpacer),_c(VBtn,{attrs:{"icon":"","disabled":!_vm.canCreate},on:{"click":_vm.addChild}},[_c(VIcon,[_vm._v("add")])],1)],1),_c(VList,_vm._l((_vm.empleos),function(empleo){return _c(VListItem,{key:empleo.orden},[_c('app-empleo-completo',{ref:"hijos",refInFor:true,attrs:{"value":empleo,"empleos":_vm.empleos}})],1)}),1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }